import { render, staticRenderFns } from "./land-safe.vue?vue&type=template&id=35f372d5"
import script from "./land-safe.vue?vue&type=script&lang=js"
export * from "./land-safe.vue?vue&type=script&lang=js"
import style0 from "./land-safe.vue?vue&type=style&index=0&id=35f372d5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports